
import "../Text/Text.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_GooglePreview";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_GooglePreview__root","googlePreviewTitle":"wds_1_130_0_GooglePreview__googlePreviewTitle","googlePreviewUrl":"wds_1_130_0_GooglePreview__googlePreviewUrl","googlePreviewDescription":"wds_1_130_0_GooglePreview__googlePreviewDescription","googlePreviewSiteName":"wds_1_130_0_GooglePreview__googlePreviewSiteName","googlePreviewWebsiteInfo":"wds_1_130_0_GooglePreview__googlePreviewWebsiteInfo","googlePreviewWebsiteInfoContent":"wds_1_130_0_GooglePreview__googlePreviewWebsiteInfoContent","googlePreviewWebsiteInfoCTA":"wds_1_130_0_GooglePreview__googlePreviewWebsiteInfoCTA","googlePreviewFaviconBox":"wds_1_130_0_GooglePreview__googlePreviewFaviconBox"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"googlePreviewBlue":"#260AA8","googlePreviewBlack":"#202124","googlePreviewGray":"#4D5156","googlePreviewLightGray":"#E6E6E6","googlePreviewWhite":"#F1F3F4"}; 
export var vars = {}; 




